if (!customElements.get("filter-based-results")) {
    class FilterBasedResults extends HTMLElement {
        constructor() {
            super();

            this.validUrl = null;
            this.metafieldsName = null;
            this.form = this.querySelector("form");
            this.departmentsList = this.form.querySelector("#DepartmentsList");
            this.optionsSelect = this.form.querySelector("#options-list");
            this.metafieldsSelect = this.form.querySelector("#metafields-list");
            this.multiMetafieldsSelect = this.form.querySelector(
                "#multi-metafields-list"
            );
            this.data = this.fetchFiltersJsonData();

            this.bindEvents();
        }

        fetchFiltersJsonData() {
            const json = document.getElementById("department-filters-data");
            return JSON.parse(json?.textContent);
        }

        bindEvents() {
            this.departmentsList.addEventListener("click", (e) => {
                e.preventDefault();
                const department = e.target.dataset.value;

                if (!department || !this.data[department]) return;

                this.resetOptions();
                this.updateSummaryValue(e);
                this.form.dataset.department = department;
                this.renderOptions(department);
                this.renderMetafieldsOptions(department);
            });

            // update action state
            this.optionsSelect &&
                this.optionsSelect.addEventListener(
                    "click",
                    this.toggleAction.bind(this)
                );
            this.metafieldsSelect &&
                this.metafieldsSelect.addEventListener(
                    "click",
                    this.toggleAction.bind(this)
                );
            this.multiMetafieldsSelect &&
                this.multiMetafieldsSelect.addEventListener(
                    "click",
                    this.toggleAction.bind(this)
                );

            // submit form
            this.form.addEventListener("submit", this.handleSubmit.bind(this));
        }

        toggleAction(e) {
            this.updateSummaryValue(e);

            const optionValue = e.target?.dataset.value;
            this.updateActionState(optionValue);
        }

        handleSubmit(e) {
            e.preventDefault();
            if (this.validUrl) window.location.href = this.validUrl;
        }

        async updateActionState(value) {
            const action = this.form.querySelector('button[type="submit"]');
            action.textContent = action.dataset.label;
            action.setAttribute("disabled", true);

            if (this.isValidSelection() > 0) return;
            const url = await this.getActionUrl();
            if (url == null) {
                this.validUrl = null;
                return;
            } else {
                this.validUrl = url;
                action.removeAttribute("disabled");
            }
        }

        async getActionUrl() {
            const department = this.form?.dataset?.department;
            if (!department) return null;

            const baseUrl = `/collections/${department}`;

            const getActive = (container) =>
                container?.querySelector("li.active")?.dataset;

            const option = getActive(this.optionsSelect);
            const metafield = getActive(this.metafieldsSelect);
            const multiMetafield = getActive(this.multiMetafieldsSelect);

            const params = new URLSearchParams();

            // product option
            if (option?.value) {
                const normalizedName = option.option
                    .toLowerCase()
                    .replace(/\s+/g, "-");
                params.append(
                    `filter.v.option.${normalizedName}`,
                    option.value
                );
            }

            // single metafield
            if (metafield?.value) {
                const name = this.metafieldsSelect?.dataset?.metafieldsName;
                if (name) {
                    params.append(`filter.p.m.${name}`, metafield.value);
                }
            }

            // multi metafield
            if (multiMetafield?.value) {
                const name =
                    this.multiMetafieldsSelect?.dataset?.metafieldsName;
                if (name) {
                    params.append(`filter.p.m.${name}`, multiMetafield.value);
                }
            }

            if (!params.toString()) return baseUrl;

            params.append("sort_by", "title-ascending");

            const url = `${baseUrl}?${params.toString()}`;
            const hasResults = await this.hasResults(url);

            return hasResults ? url : null;
        }

        async hasResults(url) {
            const config = {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
            };

            try {
                const response = await fetch(url, config);

                if (!response.ok) return false;

                const html = await response.text();
                const parser = new DOMParser();
                const content = parser.parseFromString(html, "text/html");
                const products = content.querySelectorAll(
                    "#main-collection-products > .grid-item"
                );
                // update action title
                const action = this.form.querySelector('button[type="submit"]');
                action.textContent = `Found ${products.length} item(s)`;
                // console.log(products.length);
                return products.length > 0;
            } catch (e) {
                console.error("Fetch failed:", e);
                return false;
            }
        }

        isValidSelection() {
            return this.form.querySelectorAll(
                'summary[data-valid-value="false"]'
            ).length;
        }

        resetOptions() {
            if (this.optionsSelect) this.optionsSelect.innerHTML = "";
            if (this.metafieldsSelect) this.metafieldsSelect.innerHTML = "";
            if (this.multiMetafieldsSelect)
                this.multiMetafieldsSelect.innerHTML = "";

            // reset summary
            this.form.querySelectorAll("summary").forEach((summary) => {
                summary.dataset.validValue = false;
                summary.firstElementChild.innerHTML =
                    summary?.dataset?.value || "";
            });
        }

        renderOptions(departmentHandle) {
            const departmentData = this.data[departmentHandle];
            if (!departmentData || !departmentData.options) return;

            departmentData.options.forEach((opt) => {
                const option = document.createElement("li");
                option.classList.add("option-item");
                option.setAttribute("role", "button");
                option.dataset.option = opt.name;
                option.dataset.value = opt.handle;
                option.textContent = `${opt.name} - ${opt.value}`;
                this.optionsSelect.appendChild(option);
            });
            this.optionsSelect &&
                this.optionsSelect
                    .closest("details")
                    .classList.remove("disabled");
        }

        renderMetafieldsOptions(departmentHandle) {
            const departmentData = this.data[departmentHandle];
            if (!departmentData) return;

            const renderList = (list, container) => {
                if (!list || !container) return;

                list.forEach((opt) => {
                    if (opt == null) return;

                    const li = document.createElement("li");
                    li.className = "option-item";
                    li.setAttribute("role", "button");
                    li.dataset.value = li.dataset.option = opt;
                    li.textContent = opt;

                    container.appendChild(li);
                });

                container.closest("details")?.classList.remove("disabled");
            };

            renderList(departmentData.metafields, this.metafieldsSelect);
            renderList(
                departmentData.multi_metafields,
                this.multiMetafieldsSelect
            );
        }

        removeActiveClass(e) {
            const list = e.target.closest("ul");
            const activeList = list.querySelectorAll("li.active");
            activeList.forEach((opt) => opt.classList.remove("active"));
        }

        closeDetails(e) {
            const details = this.form.querySelectorAll("details");
            if (!details) return;
            details.forEach((detail) => detail.removeAttribute("open"));
        }

        updateSummaryValue(e) {
            this.removeActiveClass(e);
            this.closeDetails(e);

            const details = e.target.closest("details");
            const summary = details.querySelector("summary");
            summary.dataset.validValue = true;
            summary.firstElementChild.innerHTML = e.target.textContent;
            // item active class
            e.target.classList.add("active");
        }
    }
    customElements.define("filter-based-results", FilterBasedResults);
}
